var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderOpen = function SvgFolderOpen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h5.175a1.98 1.98 0 0 1 1.4.575L12 6h9q.424 0 .712.287Q22 6.576 22 7q0 .424-.288.713A.97.97 0 0 1 21 8h-9.825l-2-2H4v12l1.975-6.575q.2-.65.738-1.038A2 2 0 0 1 7.9 10h12.9q1.024 0 1.613.813.587.812.312 1.762l-1.8 6a1.95 1.95 0 0 1-.738 1.038A2 2 0 0 1 19 20zm2.1-2H19l1.8-6H7.9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderOpen);
export { ForwardRef as ReactComponent };